import { createContext, useContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage";
import { ToWords } from "to-words";
import Num2persian from "./../constants/num2persian";
import useRequests from "./useRequests";
import useFunctions from "./useFunction";
import useCommon from "./useCommon";

import { countries, setCountries } from "./countries";
import useAuth from "./useAuth";
import useCanstants from "./useCanstants";

import { getLanguage, setLanguage, useTranslation } from "react-multi-lang";
import { async } from "q";
const SharedContext = createContext();

export const SharedProvider = ({ children }) => {
  // const localStorage = useLocalStorage("user", null);
  const [user, setUser] = useLocalStorage("user", null);
  const t = useTranslation();
  const http = useRequests();
  const com = useCommon();
  const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const consts = useCanstants();
  const funs = useFunctions();

  const [roles, setRoles] = useState([]);
  const [photo, setPhoto] = useState();
  const [progress, setProgress] = useState(0);
  const [itemCounts, setItemCounts] = useState(null);

  const [model, setModel] = useState(null);
  const [models, setModels] = useState([]);
  const [showSearchBox, setShowSearchBox] = useState(false);
  const [showNewModelDialog, setShowNewModelDialog] = useState(false);
  const [showViewDialog, setShowViewDialog] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [openUploadFileDialog, setOpenUploadFileDialog] = useState(false);
  const [openApproveDialog, setOpenApproveDialog] = useState(false);
  const [getOnce, setGetOnce] = useState(false);
  const [showFilesModal, setShowFilesModal] = useState(false);
  const [generatePDF, setGeneratePDF] = useState(false);
  const [showRentalCloseDialog, setShowRentalCloseDialog] = useState(false);
  const [message, setMessage] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [notifications, setNotifications] = useState({
    invoiceNotes: [],
    tariffNotes: []
  });
  const [pushSideBar, setPushSideBar] = useState(false);

  const toWords = (currency = "USD") =>
    new ToWords({
      localeCode: "en-US",
      converterOptions: {
        currency: true,
        ignoreDecimal: false,
        ignoreZeroCurrency: false,
        doNotAddOnly: false,
        currencyOptions: {
          // can be used to override defaults for the selected locale
          name: currency === "USD" ? "Dollar" : currency,
          plural: currency === "USD" ? "Dollars" : currency,
          symbol: "$",
          fractionalUnit: {
            name: "cents",
            plural: "Cents",
            symbol: "%"
          }
        }
      }
    });
  // const [userList, setUserList] = useState([])

  const getUserRoles = async () => {
    if (user?.user) {
      const res = await http.post("api/rolesAdvanceSearch?nameId=true");
      if (res.data.success) {
        setRoles(res.data.data);
      }
    }
  };

  useEffect(() => {
    if (roles.length === 0) {
      getUserRoles();
    }
  }, [roles]);

  const uploadPhoto = async model => {
    if (user?.user) {
      try {
        if (photo?.photo) {
          const formData = new FormData();
          formData.append("photo", photo.photo);
          formData.append("model", model);
          const res = await http.upload("api/upload/photo", formData, event => {
            setProgress(Math.round(event.progress * 100));
          });

          return res;
        }
      } catch (err) {
        return err;
      }
      return false;
    }
  };

  async function fetchModelCounts() {
    if (localStorage?.user?.user) {
      try {
        const res = await http.get("api/getModelCount");

        if (res.data.success) {
          setItemCounts(res.data.data);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  useEffect(() => {
    getNotifications();
  }, []);

  async function getNotifications() {
    if (auth?.user?.user) {
      try {
        const res = await http.post("api/getNotifications", {});
        console.log("getNotifications", res);
        if (res?.data?.success) {
          setNotifications(res?.data?.data);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  const sendNotificationEmail = model => {
    http.post(`api/emails`, { model }).then(res => {
      console.log("email ", res);
    });
  };

  const value = {
    http,
    com,
    auth,
    user,
    setUser,
    location,
    navigate,
    roles,
    photo,
    setPhoto,
    uploadPhoto,
    progress,
    consts,
    itemCounts,
    fetchModelCounts,
    funs,
    setProgress,
    model,
    setModel,
    models,
    setModels,
    showSearchBox,
    setShowSearchBox,
    showNewModelDialog,
    setShowNewModelDialog,
    showViewDialog,
    setShowViewDialog,
    showDeleteDialog,
    setShowDeleteDialog,
    openUploadFileDialog,
    setOpenUploadFileDialog,
    openApproveDialog,
    setOpenApproveDialog,
    showFilesModal,
    setShowFilesModal,
    showRentalCloseDialog,
    setShowRentalCloseDialog,
    getOnce,
    setGetOnce,
    sendNotificationEmail,
    openDrawer,
    setOpenDrawer,
    notifications,
    getNotifications,
    countries,
    setCountries,
    generatePDF,
    setGeneratePDF,
    message,
    setMessage,
    getLanguage,
    setLanguage,
    t,
    toWords,
    Num2persian,
    pushSideBar,
    setPushSideBar
  };

  return (
    <SharedContext.Provider value={value}>{children}</SharedContext.Provider>
  );
};

export const useShared = () => {
  return useContext(SharedContext);
};
